module.exports = __webpack_public_path__ + "img/noData.2eaccf15.png";